const user = {
  state: {
    userInfo: {},
  },

  mutations: {
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo;
    },
  },

  actions: {
    setUserInfo({ commit }, type) {
      commit('SET_USER_INFO', type);
    },
  },
};

export default user;
